import { getCookie } from "@litres/utils";
import type { IMyBooksRoute } from "./utils/types";
import { EMyBooksRoute } from "./utils/enums";

export const SUBSCRIPTION = "/abonement/";
export const ONLY_LITRES_COLLECTION = "/tags/tolko-na-litres/";
export const LITRES_SUBSCRIPTION = "/litres_subscription/?erid=LjN8KaZp8";

export const IS_PHONE_ASKED_COOKIE = "is_phone_asked";
export const ONE_WEEK_IN_SEC = 60 * 60 * 24 * 7;

export const myBooksRoutes: Record<EMyBooksRoute, IMyBooksRoute> = {
  [EMyBooksRoute.READ_AND_LISTEN]: {
    name: "Читаю и слушаю",
  },
  [EMyBooksRoute.PURCHASED]: {
    name: "Мои",
    counterKey: "received",
  },
  [EMyBooksRoute.LIKED]: {
    name: "Отложено",
    counterKey: "wishlist",
  },
  [EMyBooksRoute.LIBRARY]: {
    name: "Библиотечные",
  },
  [EMyBooksRoute.FOLDERS]: {
    name: "Списки",
  },
  [EMyBooksRoute.CART]: {
    name: "Корзина",
    counterKey: "in_cart",
  },
  [EMyBooksRoute.CAMPAIGNS]: {
    name: "Мои акции",
  },
};

export const PERSONAL_CABINET_LOGIN = getCookie("new_user_credentials")
  ? "/me/credentials/"
  : "/pages/personal_cabinet_login/";
export const PERSONAL_CABINET_NOTIFICATIONS =
  "/pages/personal_cabinet_notifications/";
export const LOGIN = "/pages/login/";
export const MY_BOOKS_ALL = "/pages/my_books_all/";
export const SUPPORT_URL = "https://litres.helpdeskeddy.com/ru";

export const DROPDOWN_APP_LANGUAGES = [
  {
    id: "en",
    value: "ENG",
    content: {
      title: "English",
      flag: "gb",
      domain: "litres.com",
    },
  },
  {
    id: "az",
    value: "AZ",
    content: {
      title: "Azərbaycan",
      flag: "az",
      domain: "litres.az",
    },
  },
  {
    id: "uz",
    value: "UZ",
    content: {
      title: "O'zbek",
      flag: "uz",
      domain: "litres.uz",
    },
  },
  {
    id: "tr",
    value: "TR",
    content: {
      title: "Türkçe",
      flag: "tr",
      domain: "litres-tr.com",
    },
  },
  {
    id: "de",
    value: "DE",
    content: {
      title: "Deutsch",
      flag: "de",
      domain: "litres.de",
    },
  },
  {
    id: "pl",
    value: "PL",
    content: {
      title: "Polski",
      flag: "pl",
      domain: "litres.pl",
    },
  },
  {
    id: "es",
    value: "ES",
    content: {
      title: "Español",
      flag: "es",
      domain: "litres.es",
    },
  },
  {
    id: "et",
    value: "ET",
    content: {
      title: "Eesti keel",
      flag: "ee",
      domain: "litres.ee",
    },
  },
];
